import { ResolutionFilter } from "../type";

interface ResolutionFilterProps {
    resolution: ResolutionFilter;
    is_mins: boolean
    setResolution: (value: ResolutionFilter) => void;
}
  
  const resolutions = [
    { id: "fivemins", label: "5 mins", value: ResolutionFilter.FIVEMINS },
    { id: "tenmins", label: "10 mins", value: ResolutionFilter.TENMINS },
    { id: "thirtymins", label: "30 mins", value: ResolutionFilter.THIRTYMINS },
    { id: "hour", label: "Hourly", value: ResolutionFilter.HOURLY },
    { id: "daily", label: "Daily", value: ResolutionFilter.DAILY },
    { id: "weekly", label: "Weekly", value: ResolutionFilter.WEEKLY },
    { id: "monthly", label: "Monthly", value: ResolutionFilter.MONTHLY },
  ];
  
  const ResolutionRadio: React.FC<ResolutionFilterProps> = ({ resolution, is_mins, setResolution }) => {
    const filteredResolutions = resolutions.filter((res) => {
      if (!is_mins && (res.value === ResolutionFilter.THIRTYMINS || res.value === ResolutionFilter.FIVEMINS ||
        res.value === ResolutionFilter.TENMINS
      )) {
        return false;
      }
      return true;
    });
    return (
      <div className="flex items-center h-1/2">
        <div className={`gap-4 gap-x-8 xl:gap-10 ${is_mins ? 'grid grid-cols-3 md:grid-cols-5 lg:grid-cols-7' : 'flex flex-row '}`}>
          {filteredResolutions.map(({ id, label, value }) => (
            <div key={id} className="inline-flex items-center">
              <label className="relative flex items-center cursor-pointer" htmlFor={id}>
                <input
                  name="resolution"
                  type="radio"
                  id={id}
                  checked={resolution === value}
                  onChange={() => setResolution(value)}
                  className="peer h-5 w-5 cursor-pointer appearance-none rounded-full border border-gray-nor checked:border-green transition-all"
                />
                <span className="absolute bg-green w-3 h-3 rounded-full opacity-0 peer-checked:opacity-100 transition-opacity duration-200 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"></span>
              </label>
              <label className="ml-2 text-black cursor-pointer text-sm trauncate" htmlFor={id}>
                {label}
              </label>
            </div>
          ))}
        </div>
      </div>
    );
  };
  
export default ResolutionRadio